import { useTrpc } from '@client/hooks/api/useTrpc';
import type { DehydratedFormSchema } from '@shared/schemas/dynamic-forms/schema-normaliser';

// Lives outside ~route.tsx (exports in a route file defeat TanStack autoCodeSplitting).
// Referenced from the route's beforeLoad breadcrumb, so it stays in the eager graph — keep
// this module import-light.

/**
 * The form's name, as the editor's header shows it: the schema title respondents
 * see, falling back to the internal definition name while the form has no title
 * of its own. Naming the definition separately in Settings must not leave the
 * crumb and the heading disagreeing about which form this is.
 */
export function FormNameCrumb({ formDefinitionId }: { formDefinitionId: string }) {
    const { trpc } = useTrpc();
    const { data, isPending } = trpc.formDesigner.getFormDefinition.useQuery({
        formDefinitionId: BigInt(formDefinitionId),
    });
    if (isPending) return <>Form</>;

    const schemaTitle = (data?.Versions[0]?.runtimeSchema as DehydratedFormSchema | undefined)?.title?.trim();

    return <>{schemaTitle || data?.name || 'Untitled form'}</>;
}
